import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
const MoreBookingDetail = (t0) => {
    const $ = _c(11);
    let onOpenModal;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ onOpenModal, className: t1, ...props } = t0);
        $[0] = t0;
        $[1] = onOpenModal;
        $[2] = props;
        $[3] = t1;
    }
    else {
        onOpenModal = $[1];
        props = $[2];
        t1 = $[3];
    }
    const className = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    let t2;
    if ($[4] !== translate) {
        t2 = translate("messages.more_details");
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const moreDetailsLabel = t2;
    const computedClassName = `btn-ghost-primary !rounded-none !text-xs ${className}`;
    let t3;
    if ($[6] !== computedClassName || $[7] !== moreDetailsLabel || $[8] !== onOpenModal || $[9] !== props) {
        t3 = <>
      <Button className={computedClassName} onClick={onOpenModal} title={moreDetailsLabel} {...props}>

        {moreDetailsLabel}
      </Button></>;
        $[6] = computedClassName;
        $[7] = moreDetailsLabel;
        $[8] = onOpenModal;
        $[9] = props;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    return t3;
};
export default MoreBookingDetail;
